export const projectsData = [
  {
    id: 'p1',
    category: 'projects',
    tags: ['frontend'],
    createdDate: new Date('2022-03-25'),
    title: 'Curated Handicrafts',
    description: 'E-commerce website for handicrafts',
    slug: 'curated-handicrafts',
    actions: {
      article: '',
    },
  },
  {
    id: 'p2',
    category: 'projects',
    tags: ['fullstack'],
    createdDate: new Date('2022-03-25'),
    title: 'Divis Vanishers',
    description: 'E-commerce website for laundry services',
    slug: 'divis-vanishers',
    actions: {
      articles: '',
    },
  },
  {
    id: 'p3',
    category: 'projects',
    tags: ['fullstack'],
    createdDate: new Date('2022-03-25'),
    title: 'Sindhura Hospital',
    description: 'Business website for the hospital',
    slug: 'sindhura-hospital',
    actions: {
      articles: '',
    },
  },
  {
    id: 'p4',
    category: 'projects',
    tags: ['browser extension'],
    createdDate: new Date('2022-03-25'),
    title: 'I Love Bookmarks',
    description:
      'A Google chrome bookmark organizer with cool icons and drag & drop feature.',
    slug: 'i-love-bookmarks',
    actions: {
      demo: 'https://chrome.google.com/webstore/detail/i-love-bookmarks/dfgjmhdilimpooppfbinonkmldfgjkab?hl=en-US',
    },
  },
];
